import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { GraduationCap, Lock, CheckCircle2 } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { Reveal, Overline } from "./Reveal";

export const Advantage = () => {
  const { t } = useLang();
  const w = t.why;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="why" ref={ref} className="py-24 lg:py-32" data-testid="advantage-section">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-2 lg:px-8">
        <div>
          <Reveal>
            <Overline>{w.over}</Overline>
            <h2 className="section-title mt-5">{w.title}</h2>
          </Reveal>
          <ul className="mt-10 divide-y divide-white/10 border-y border-white/10">
            {w.list.map((item, i) => (
              <Reveal key={item} delay={i * 0.06}>
                <li className="group flex items-center gap-5 py-5">
                  <span className="font-mono text-xs text-slate-400">0{i + 1}</span>
                  <span className="flex-1 font-display text-lg text-white transition-transform duration-300 group-hover:translate-x-2 md:text-xl">{item}</span>
                  <CheckCircle2 size={18} className="text-emerald" />
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
        <div className="flex flex-col gap-4">
          <div className="relative h-72 overflow-hidden rounded-[28px] md:h-80">
            <motion.img style={{ y, scale: 1.2 }} src="/img/woman2.jpg" alt="Woman entrepreneur using phone" className="absolute inset-0 h-full w-full object-cover" />
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <Reveal className="bento h-full">
              <GraduationCap className="text-saffron" size={26} />
              <h3 className="mt-5 font-display text-xl font-bold text-white">{w.train.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">{w.train.d}</p>
            </Reveal>
            <Reveal delay={0.1} className="bento h-full">
              <Lock className="text-emerald" size={26} />
              <h3 className="mt-5 font-display text-xl font-bold text-white">{w.safe.t}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">{w.safe.d}</p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
